import { all } from 'typed-redux-saga'

import watchRefinanciamento from './refinanciamento/saga'
import watchBiometria from './biometria/saga'

export default function* rootSaga() {
  yield* all([watchRefinanciamento(), watchBiometria()])
}
